import axios from "axios";
import router from "@/routes/router";
console.log(process.env.VUE_APP_API_URL, "process.env.VUE_APP_API_URL");

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || "http://localhost:3001/api",
  timeout: 15000,
});

// Injeta token automaticamente em todos os pedidos
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tokenAbitue");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Trata erros globalmente
// 403 SÓ faz logout se for erro de token (inválido/expirado)
// 403 de permissão (ex: staff sem acesso) NÃO faz logout
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      const msg = error.response?.data?.error || "";
      const isTokenError =
        msg.includes("Token inválido") ||
        msg.includes("Token em falta") ||
        msg.includes("expirado") ||
        msg.includes("inválida ou revogada");

      if (isTokenError) {
        localStorage.removeItem("tokenAbitue");
        localStorage.removeItem("user");
        router.push("/login");
      }
    }
    return Promise.reject(error);
  },
);

export default api;
